import { Collapse } from 'bootstrap'
import React, { Component } from 'react'
import { Card, CardDeck, Col, Container, Table } from 'react-bootstrap'
import bjj from '../photo/bjj.jpg'

export default class Bjj extends Component {
    render() {
        return ( 
            <Container >
                <h1  className="h1 "> Бондаренко Юлія Юріївна</h1>
                <hr />
                <div className="about-teach">
                    <Col sm={7}>
                        
                        <p className="p"><b> Бондаренко Юлія Юріївна</b>  - Професор, кандидат технічних наук, доцент 
                        кафедри приладобудування, мехатроніки та комп’ютеризованих
                        технологій в Черкаського державного технологічного університету, докторант за спеціальністю 
                        123 “Комп’ютерна інженерія”</p>
                        <h3 className="text-center"><b>Біографія</b> </h3><hr />
                        
                        
                        <p className="p">Закінчила Черкаський інженерно-технологічний інститут у 1999 році за спеціальністю 
                        «Прилади точної механіки» і одержала кваліфікацію інженера-електромеханіка</p>

                        <p className="p">У грудні 2003 року в Одеському національному політехнічному університеті захистила 
                        кандидатську дисертацію з технічних наук за спеціальністю 05.13.05 – комп’ютерні системи та компоненти
                        на тему «Методи лінеаризації амплітудно-частотних характеристик п’єзоелектричних перетворювачів механічних
                        величин».Вчене звання «Доцент кафедри комп’ютеризованих та інформаційних технологій у приладобудуванні» 
                        присвоєне 03 липня 2008 року. Вчене звання «Професор кафедри приладобудування, мехатроніки та 
                        комп’ютеризованих технологій» присвоєне 15 квітня 2021 року.</p>
                        <p className="p">У ЧДТУ почала працювати з 1 вересня 2000 року спочатку секретарем кафедри 
                        комп’ютеризованих та інформаційних технологій у приладобудуванні, а з 1 вересня 2016 року 
                        завідувачем цієї кафедри (з 10 вересня 2016 року кафедри приладобудування, мехатроніки та 
                        комп’ютеризованих технологій).</p>
                        <p className="p">Викладала дисциплини: </p>
                        <ul>
                            <li>«Сучасні матеріали та покриття у приладобудуванні»,</li>
                            <li>«Матеріалознавство та конструкційні матеріали»,</li>
                            <li>«Основи анатомії та фізіології людини»,</li>
                            <li>«Оптимізація прийняття рішень у техніці»,</li>
                            <li>«Основи тепло- та променевої техніки,»,</li>
                            <li>«Ергономіка та дизайн у приладобудуванні»,</li>
                            <li>«Проектування приладів побутового призначення»,</li>
                            <li>«Патентознавство та авторське право»,</li>
                            <li>«Основи телемедицини»,</li>
                            <li>«Основи наукових досліджень»,</li>
                            <li>«Математичні методи оптимізації»,</li>
                            <li>«Чинники успішного працевлаштування за фахом»,</li>
                            <li>«Теорія та техніка експерименту»,</li>
                        </ul>

                        

                        <h3 className="text-center"><b> Наукова діяльність</b></h3><hr />
                    
                        <p className="p"></p>
                        <p className="p">Інтереси: застосування нанотехнологій в техніці та медицині; застосування новітніх інформаційних 
                        технологій у телемедицині; медична діагностика за допомогою методів газорозрядної візуалізації; 
                        перетворювачі інформації для точного та медичного приладобудування.та інше.</p>  
                        <p className="p">Доцент Бондаренко Ю.Ю. є науковим керівником двох захищених аспірантів зі спеціальності 
                        05.13.05: Заїки В.М. (2015 р.), Тичкова В.В. (2018 р.) та здобувача освітньо-наукового рівня “доктор 
                        філософії” зі спеціальності 152: Топтун А.В. (2020 р.), а також трьох здобувачів освітньо-наукового рівня 
                        “доктор філософії” (Скорина Є.В., Титаренко С.В., Макаренко І.О.) зі спеціальності 152 – метрологія та 
                        інформаційно-вимірювальна техніка.</p> 
                         
                        <p className="p">Автор понад 200 наукових публікацій, з них 5 монографій і 8 навчальних посібників.</p>  
                        
                        <hr />  
                    
                    </Col>
                    <Col sm={5}>
                        
                        <CardDeck border="dark" className='m-3'>
                            <Card className="card">
                                <img
                                    
                                    src={bjj}
                                />
                                <Card.Body>
                                    <Card.Title  className="table-title"> <span ><b> БОНДАРЕНКО <br /> Юлія  Юріївна</b></span> </Card.Title> <hr />
                                    <Table >
                                        
                                        <tr>
                                            <td className="table-col-1" > Місце роботи </td> 
                                            <td className="table-col-2"> Черкаський державний технологічний університет </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Освіта </td> 
                                            <td className="table-col-2" > 
                                                <ul>
                                                    <li>Черкаський державний технологічний університет </li>
                                                </ul>
                                                
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Науковий ступінь</td> 
                                            <td className="table-col-2 "> кандидат технічних наук </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Наукове звання</td> 
                                            <td className="table-col-2 "> Професор </td>

                                        </tr>
                                    </Table>
                                    
                                    
                                </Card.Body>
                            </Card>
                        </CardDeck>
                        
                    </Col>
                    
                       
                </div>
            </Container>
        )
    }
}